import { render, staticRenderFns } from "./OwnedEarnedPostReach.vue?vue&type=template&id=089b7f0e&scoped=true&"
import script from "./OwnedEarnedPostReach.vue?vue&type=script&lang=js&"
export * from "./OwnedEarnedPostReach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089b7f0e",
  null
  
)

export default component.exports